// eslint-disable-next-line
export const REGEX_EMAIL = /^[a-z0-9.+#$!&,?_-]{1,64}@[a-z0-9.+#$!&,?_-]{1,64}$/i;
// eslint-disable-next-line
export const REGEX_PASSWORD = /^[A-Za-z0-9.!,?*%$#@]*$/;
// eslint-disable-next-line
export const REGEX_NOT_NAME_SPECIAL = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  